function toggleAnswer(answerId) {
    var answer = document.getElementById('answer' + answerId);
    if (!answer) return; // Exit if no element found
    answer.style.display = (answer.style.display === 'block' || !answer.style.display) ? 'none' : 'block';
}

// Event listener for both data-sanitized-onclick and onclick attributes
document.addEventListener('click', function(event) {
    var target = event.target;

    // Find the closest FAQ question element
    var faqQuestion = target.closest('.faq-question');
    if (!faqQuestion) return; // Exit if not a FAQ question element

    // Check for data-sanitized-onclick
    var sanitizedOnClick = faqQuestion.getAttribute('data-sanitized-onclick');
    if (sanitizedOnClick) {
        var answerId = sanitizedOnClick.match(/\d+/)[0];
        toggleAnswer(answerId);
        return;
    }

    // Check for onclick attribute
    var onClick = faqQuestion.getAttribute('onclick');
    if (onClick) {
        var answerId = onClick.match(/\d+/)[0];
        toggleAnswer(answerId);
    }
});
